import React from 'react'

export const PlaceHolder = (): JSX.Element => {
  return <div>PLACEHOLDER</div>
}
